'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { AppStoreLinks } from '@/components/app-upsells/app-store-links';
import { useUpsellImpression } from '@/components/app-upsells/use-upsell-impression';
import { DOCS_URL } from '@/config/docs-links';
import { CANNY_FEATURE_BOARD_URL } from '@/config/feedback';
import { onEvent } from '@/events';
import { Link } from '@/i18n/navigation';
import { GUTTER_CLASS } from '@/lib/ui/layout';
import { cn } from '@/lib/ui/utils';
import { useLayoutStore } from '@/stores/layout';
import { openSupport } from '@/stores/support';
const EXTERNAL_LINK_PROPS: {
  target: '_blank';
  rel: 'noopener noreferrer';
} = {
  target: '_blank',
  rel: 'noopener noreferrer'
};
const LINK_CLASS = 'block w-full cursor-pointer py-1.5 text-left text-foreground-tertiary transition-colors duration-fast hover:text-foreground-primary';
interface AppFooterProps {
  className?: string;
}
function handleSupportClick(): void {
  openSupport();
}
export function AppFooter(t0) {
  const $ = _c(155);
  const {
    className
  } = t0;
  const t = useTranslations("footer");
  const tFeedback = useTranslations("feedback");
  const openFeedback = useLayoutStore(_temp);
  const downloadRef = useUpsellImpression("footer", true, "footer");
  let t1;
  if ($[0] !== openFeedback) {
    t1 = function handleFeedbackClick() {
      onEvent("feedback_opened", {
        source: "footer",
        intent: "feedback"
      });
      openFeedback();
    };
    $[0] = openFeedback;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleFeedbackClick = t1;
  let t2;
  if ($[2] !== className) {
    t2 = cn("hidden border-solid border-t border-border-primary bg-background-secondary py-12 md:block", className);
    $[2] = className;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = cn(GUTTER_CLASS, "grid gap-8 md:grid-cols-4");
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t) {
    t4 = t("product");
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <h3 className="mb-3 text-heading-xs text-foreground-secondary">{t4}</h3>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t) {
    t6 = t("markets");
    $[9] = t;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t6) {
    t7 = <li><Link href="/markets" prefetch={false} className={LINK_CLASS}>{t6}</Link></li>;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t) {
    t8 = t("launchpad");
    $[13] = t;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t8) {
    t9 = <li><Link href="/proposals" prefetch={false} className={LINK_CLASS}>{t8}</Link></li>;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t) {
    t10 = t("social_link");
    $[17] = t;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10) {
    t11 = <li><Link href="/social" prefetch={false} className={LINK_CLASS}>{t10}</Link></li>;
    $[19] = t10;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t) {
    t12 = t("mainnet");
    $[21] = t;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== t12) {
    t13 = <li><Link href="/about" prefetch={false} className={LINK_CLASS}>{t12}</Link></li>;
    $[23] = t12;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== t11 || $[26] !== t13 || $[27] !== t7 || $[28] !== t9) {
    t14 = <ul className="text-body">{t7}{t9}{t11}{t13}</ul>;
    $[25] = t11;
    $[26] = t13;
    $[27] = t7;
    $[28] = t9;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== t14 || $[31] !== t5) {
    t15 = <div>{t5}{t14}</div>;
    $[30] = t14;
    $[31] = t5;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== t) {
    t16 = t("company");
    $[33] = t;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  let t17;
  if ($[35] !== t16) {
    t17 = <h3 className="mb-3 text-heading-xs text-foreground-secondary">{t16}</h3>;
    $[35] = t16;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] !== t) {
    t18 = t("about");
    $[37] = t;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  let t19;
  if ($[39] !== t18) {
    t19 = <li><Link href="/about" prefetch={false} className={LINK_CLASS}>{t18}</Link></li>;
    $[39] = t18;
    $[40] = t19;
  } else {
    t19 = $[40];
  }
  let t20;
  if ($[41] !== t) {
    t20 = t("learn");
    $[41] = t;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  let t21;
  if ($[43] !== t20) {
    t21 = <li><Link href="/learn" prefetch={false} className={LINK_CLASS}>{t20}</Link></li>;
    $[43] = t20;
    $[44] = t21;
  } else {
    t21 = $[44];
  }
  let t22;
  if ($[45] !== t) {
    t22 = t("brand");
    $[45] = t;
    $[46] = t22;
  } else {
    t22 = $[46];
  }
  let t23;
  if ($[47] !== t22) {
    t23 = <li><Link href="/brand" prefetch={false} className={LINK_CLASS}>{t22}</Link></li>;
    $[47] = t22;
    $[48] = t23;
  } else {
    t23 = $[48];
  }
  let t24;
  if ($[49] !== t) {
    t24 = t("support");
    $[49] = t;
    $[50] = t24;
  } else {
    t24 = $[50];
  }
  let t25;
  if ($[51] !== t24) {
    t25 = <li><button type="button" onClick={handleSupportClick} className={LINK_CLASS}>{t24}</button></li>;
    $[51] = t24;
    $[52] = t25;
  } else {
    t25 = $[52];
  }
  let t26;
  if ($[53] !== t) {
    t26 = t("documentation");
    $[53] = t;
    $[54] = t26;
  } else {
    t26 = $[54];
  }
  let t27;
  if ($[55] !== t26) {
    t27 = <li><a href={DOCS_URL} {...EXTERNAL_LINK_PROPS} className={LINK_CLASS}>{t26}</a></li>;
    $[55] = t26;
    $[56] = t27;
  } else {
    t27 = $[56];
  }
  let t28;
  if ($[57] !== tFeedback) {
    t28 = tFeedback("menu.send_feedback");
    $[57] = tFeedback;
    $[58] = t28;
  } else {
    t28 = $[58];
  }
  let t29;
  if ($[59] !== handleFeedbackClick || $[60] !== t28) {
    t29 = <li><button type="button" onClick={handleFeedbackClick} className={LINK_CLASS}>{t28}</button></li>;
    $[59] = handleFeedbackClick;
    $[60] = t28;
    $[61] = t29;
  } else {
    t29 = $[61];
  }
  let t30;
  if ($[62] !== tFeedback) {
    t30 = tFeedback("menu.feature_board");
    $[62] = tFeedback;
    $[63] = t30;
  } else {
    t30 = $[63];
  }
  let t31;
  if ($[64] !== t30) {
    t31 = <li><a href={CANNY_FEATURE_BOARD_URL} {...EXTERNAL_LINK_PROPS} data-canny-link={true} className={LINK_CLASS}>{t30}</a></li>;
    $[64] = t30;
    $[65] = t31;
  } else {
    t31 = $[65];
  }
  let t32;
  if ($[66] !== t19 || $[67] !== t21 || $[68] !== t23 || $[69] !== t25 || $[70] !== t27 || $[71] !== t29 || $[72] !== t31) {
    t32 = <ul className="text-body">{t19}{t21}{t23}{t25}{t27}{t29}{t31}</ul>;
    $[66] = t19;
    $[67] = t21;
    $[68] = t23;
    $[69] = t25;
    $[70] = t27;
    $[71] = t29;
    $[72] = t31;
    $[73] = t32;
  } else {
    t32 = $[73];
  }
  let t33;
  if ($[74] !== t17 || $[75] !== t32) {
    t33 = <div>{t17}{t32}</div>;
    $[74] = t17;
    $[75] = t32;
    $[76] = t33;
  } else {
    t33 = $[76];
  }
  let t34;
  if ($[77] !== t) {
    t34 = t("legal");
    $[77] = t;
    $[78] = t34;
  } else {
    t34 = $[78];
  }
  let t35;
  if ($[79] !== t34) {
    t35 = <h3 className="mb-3 text-heading-xs text-foreground-secondary">{t34}</h3>;
    $[79] = t34;
    $[80] = t35;
  } else {
    t35 = $[80];
  }
  let t36;
  if ($[81] !== t) {
    t36 = t("terms");
    $[81] = t;
    $[82] = t36;
  } else {
    t36 = $[82];
  }
  let t37;
  if ($[83] !== t36) {
    t37 = <li><Link href="/terms" prefetch={false} className={LINK_CLASS}>{t36}</Link></li>;
    $[83] = t36;
    $[84] = t37;
  } else {
    t37 = $[84];
  }
  let t38;
  if ($[85] !== t) {
    t38 = t("privacy");
    $[85] = t;
    $[86] = t38;
  } else {
    t38 = $[86];
  }
  let t39;
  if ($[87] !== t38) {
    t39 = <li><Link href="/privacy" prefetch={false} className={LINK_CLASS}>{t38}</Link></li>;
    $[87] = t38;
    $[88] = t39;
  } else {
    t39 = $[88];
  }
  let t40;
  if ($[89] !== t) {
    t40 = t("risk");
    $[89] = t;
    $[90] = t40;
  } else {
    t40 = $[90];
  }
  let t41;
  if ($[91] !== t40) {
    t41 = <li><Link href="/risk" prefetch={false} className={LINK_CLASS}>{t40}</Link></li>;
    $[91] = t40;
    $[92] = t41;
  } else {
    t41 = $[92];
  }
  let t42;
  if ($[93] !== t37 || $[94] !== t39 || $[95] !== t41) {
    t42 = <ul className="text-body">{t37}{t39}{t41}</ul>;
    $[93] = t37;
    $[94] = t39;
    $[95] = t41;
    $[96] = t42;
  } else {
    t42 = $[96];
  }
  let t43;
  if ($[97] !== t35 || $[98] !== t42) {
    t43 = <div>{t35}{t42}</div>;
    $[97] = t35;
    $[98] = t42;
    $[99] = t43;
  } else {
    t43 = $[99];
  }
  let t44;
  if ($[100] !== t) {
    t44 = t("social");
    $[100] = t;
    $[101] = t44;
  } else {
    t44 = $[101];
  }
  let t45;
  if ($[102] !== t44) {
    t45 = <h3 className="mb-3 text-heading-xs text-foreground-secondary">{t44}</h3>;
    $[102] = t44;
    $[103] = t45;
  } else {
    t45 = $[103];
  }
  let t46;
  if ($[104] !== t) {
    t46 = t("x_twitter");
    $[104] = t;
    $[105] = t46;
  } else {
    t46 = $[105];
  }
  let t47;
  if ($[106] !== t46) {
    t47 = <li><a href="https://x.com/morfimarkets" {...EXTERNAL_LINK_PROPS} className={LINK_CLASS}>{t46}</a></li>;
    $[106] = t46;
    $[107] = t47;
  } else {
    t47 = $[107];
  }
  let t48;
  if ($[108] !== t) {
    t48 = t("reddit");
    $[108] = t;
    $[109] = t48;
  } else {
    t48 = $[109];
  }
  let t49;
  if ($[110] !== t48) {
    t49 = <li><a href="https://www.reddit.com/user/morfimarkets/" {...EXTERNAL_LINK_PROPS} className={LINK_CLASS}>{t48}</a></li>;
    $[110] = t48;
    $[111] = t49;
  } else {
    t49 = $[111];
  }
  let t50;
  if ($[112] !== t) {
    t50 = t("instagram");
    $[112] = t;
    $[113] = t50;
  } else {
    t50 = $[113];
  }
  let t51;
  if ($[114] !== t50) {
    t51 = <li><a href="https://www.instagram.com/morfimarkets/" {...EXTERNAL_LINK_PROPS} className={LINK_CLASS}>{t50}</a></li>;
    $[114] = t50;
    $[115] = t51;
  } else {
    t51 = $[115];
  }
  let t52;
  if ($[116] !== t) {
    t52 = t("facebook");
    $[116] = t;
    $[117] = t52;
  } else {
    t52 = $[117];
  }
  let t53;
  if ($[118] !== t52) {
    t53 = <li><a href="https://www.facebook.com/profile.php?id=61567201515508" {...EXTERNAL_LINK_PROPS} className={LINK_CLASS}>{t52}</a></li>;
    $[118] = t52;
    $[119] = t53;
  } else {
    t53 = $[119];
  }
  let t54;
  if ($[120] !== t) {
    t54 = t("tiktok");
    $[120] = t;
    $[121] = t54;
  } else {
    t54 = $[121];
  }
  let t55;
  if ($[122] !== t54) {
    t55 = <li><a href="https://www.tiktok.com/@morfimarkets" {...EXTERNAL_LINK_PROPS} className={LINK_CLASS}>{t54}</a></li>;
    $[122] = t54;
    $[123] = t55;
  } else {
    t55 = $[123];
  }
  let t56;
  if ($[124] !== t) {
    t56 = t("telegram");
    $[124] = t;
    $[125] = t56;
  } else {
    t56 = $[125];
  }
  let t57;
  if ($[126] !== t56) {
    t57 = <li><a href="https://t.me/morfimarkets" {...EXTERNAL_LINK_PROPS} className={LINK_CLASS}>{t56}</a></li>;
    $[126] = t56;
    $[127] = t57;
  } else {
    t57 = $[127];
  }
  let t58;
  if ($[128] !== t47 || $[129] !== t49 || $[130] !== t51 || $[131] !== t53 || $[132] !== t55 || $[133] !== t57) {
    t58 = <ul className="text-body">{t47}{t49}{t51}{t53}{t55}{t57}</ul>;
    $[128] = t47;
    $[129] = t49;
    $[130] = t51;
    $[131] = t53;
    $[132] = t55;
    $[133] = t57;
    $[134] = t58;
  } else {
    t58 = $[134];
  }
  let t59;
  if ($[135] !== t45 || $[136] !== t58) {
    t59 = <div>{t45}{t58}</div>;
    $[135] = t45;
    $[136] = t58;
    $[137] = t59;
  } else {
    t59 = $[137];
  }
  let t60;
  if ($[138] !== t15 || $[139] !== t33 || $[140] !== t43 || $[141] !== t59) {
    t60 = <div className={t3}>{t15}{t33}{t43}{t59}</div>;
    $[138] = t15;
    $[139] = t33;
    $[140] = t43;
    $[141] = t59;
    $[142] = t60;
  } else {
    t60 = $[142];
  }
  let t61;
  if ($[143] === Symbol.for("react.memo_cache_sentinel")) {
    t61 = cn(GUTTER_CLASS, "mt-8 border-solid border-t border-border-primary pt-6 text-center text-micro text-foreground-tertiary");
    $[143] = t61;
  } else {
    t61 = $[143];
  }
  let t62;
  if ($[144] !== downloadRef) {
    t62 = <AppStoreLinks ref={downloadRef} surface="footer" entryPoint="footer" className="mb-4 justify-center" />;
    $[144] = downloadRef;
    $[145] = t62;
  } else {
    t62 = $[145];
  }
  let t63;
  if ($[146] !== t) {
    t63 = t("copyright");
    $[146] = t;
    $[147] = t63;
  } else {
    t63 = $[147];
  }
  let t64;
  if ($[148] !== t62 || $[149] !== t63) {
    t64 = <div className={t61}>{t62}{t63}</div>;
    $[148] = t62;
    $[149] = t63;
    $[150] = t64;
  } else {
    t64 = $[150];
  }
  let t65;
  if ($[151] !== t2 || $[152] !== t60 || $[153] !== t64) {
    t65 = <footer className={t2}>{t60}{t64}</footer>;
    $[151] = t2;
    $[152] = t60;
    $[153] = t64;
    $[154] = t65;
  } else {
    t65 = $[154];
  }
  return t65;
}
function _temp(s) {
  return s.openFeedback;
}